import { datadogLogs } from '@datadog/browser-logs';
import { env } from './env/constants';
import { getMode } from './env/feature-flag';
import { redactCredentialsDeep } from './security/redact-credentials';
const isDatadogEnabled = () => !!env.VITE_DATADOG_ENABLED;
const getDatadogToken = () => env.VITE_DATADOG_CLIENT_TOKEN ?? '';
export const initializeLogger = () => {
  if (isDatadogEnabled()) {
    const mode = getMode();
    datadogLogs.init({
      clientToken: getDatadogToken(),
      site: 'ap1.datadoghq.com',
      service: 'dresscode-frontend',
      env: mode,
      // see vite.config.ts
      version: import.meta.env.PACKAGE_VERSION,
      forwardErrorsToLogs: true,
      // console logは料金に跳ねそうなので送らない
      forwardConsoleLogs: ['error'],
      sessionSampleRate: 100,
      // view.url や forwardErrorsToLogs のメッセージは呼び出し側で制御できないため、
      // 送信前の唯一の関門であるここで一括して伏字化する。
      // 失敗時は false を返して捨てる。SDK は例外を握り潰して undefined を返し、
      // それだと素の値が送信されてしまう（fail-open）。
      beforeSend: event => {
        try {
          redactCredentialsDeep(event);
          return true;
        } catch {
          return false;
        }
      }
    });
  }
};
export const injectLogContext = (context: {
  dressCodeUserId: string;
  tenantId: string;
  organizationId: string;
}) => {
  if (isDatadogEnabled()) {
    datadogLogs.setUser({
      id: context.dressCodeUserId,
      tenantId: context.tenantId,
      organizationId: context.organizationId
    });
  }
};
type LogContext = Record<string, unknown>;
const toError = (value: unknown): Error | undefined => {
  if (value === undefined) return undefined;
  if (value instanceof Error) return value;
  return new Error(String(value), {
    cause: value
  });
};

/**
 * ログ基盤（Datadog）を差し替え可能にするラッパー。
 *
 * error は第 2 引数が付随情報、第 3 引数がエラー本体。Error を第 2 引数へ渡すと
 * stack が失われ Error Tracking に載らないため、型で防いでいる。
 */
export const getLogger = () => {
  return {
    info: (message: string, context?: LogContext) => datadogLogs.logger.info(message, context),
    warn: (message: string, context?: LogContext) => datadogLogs.logger.warn(message, context),
    error: (message: string, context?: LogContext, error?: unknown) => datadogLogs.logger.error(message, context, toError(error))
  };
};